"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormInline = exports.FormCellLabel = exports.FormLine = exports.FormCell = exports.FormRow = exports.FormGroup = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var form_1 = require("../form");
var tooltip_1 = require("./tooltip");
var fat_1 = require("remota-common/util/fat");
var FormGroup = function (props) {
    return (react_1.default.createElement(FormPane, __assign({}, props),
        react_1.default.createElement(MainLabelPane, __assign({}, props),
            react_1.default.createElement(form_1.MainLabel, null,
                react_1.default.createElement(fat_1.Fat, { id: props.label }),
                !props.tooltip ? null : react_1.default.createElement(tooltip_1.Tooltip, { tooltip: props.tooltip }))),
        react_1.default.createElement(MainAreaPane, { fullwidth: props.fullwidth || false }, props.children)));
};
exports.FormGroup = FormGroup;
var FormPane = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 8px;\n  align-items: ", ";\n"], ["\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 8px;\n  align-items: ", ";\n"])), function (props) { return (props.centerAligned ? "center" : "flex-start"); });
var MainLabelPane = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex: 0 0 200px;\n  ", "\n"], ["\n  flex: 0 0 200px;\n  ", "\n"])), function (props) { return (props.withPaddingTop ? "padding-top: 12px;" : ""); });
var MainAreaPane = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  flex: ", ";\n"], ["\n  flex: ", ";\n"])), function (props) { return (props.fullwidth ? "1 0" : "0 0 400px"); });
exports.FormRow = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  margin: 0 -10px 16px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  margin: 0 -10px 16px;\n"])));
exports.FormCell = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n  padding: 0 10px;\n"], ["\n  ", ";\n  padding: 0 10px;\n"])), function (props) {
    var flex = props.flex, px = props.px, percent = props.percent, col = props.col;
    if (flex !== undefined) {
        return {
            flex: flex,
        };
    }
    else if (px !== undefined) {
        return {
            flex: "0 0 ".concat(px, "px"),
            maxWidth: "".concat(px, "px"),
        };
    }
    else if (percent !== undefined) {
        return {
            flex: "0 0 ".concat(percent, "%"),
            maxWidth: "".concat(percent, "%"),
        };
    }
    else if (col !== undefined) {
        return {
            flex: "0 0 ".concat((col / 12) * 100, "%"),
            maxWidth: "".concat((col / 12) * 100, "%"),
        };
    }
    else {
        return undefined;
    }
});
var FormLine = function (props) {
    return (react_1.default.createElement(LinePane, { hidden: props.hidden },
        !props.label ? null : (react_1.default.createElement(SubLabelPane, null,
            react_1.default.createElement(form_1.SubLabel, null,
                props.label,
                !props.tooltip ? null : react_1.default.createElement(tooltip_1.Tooltip, { tooltip: props.tooltip })))),
        react_1.default.createElement(InputAreaPane, null, props.children)));
};
exports.FormLine = FormLine;
var LinePane = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: ", ";\n  flex-direction: column;\n"], ["\n  display: ", ";\n  flex-direction: column;\n"])), function (props) { return (props.hidden ? "none" : "flex"); });
var SubLabelPane = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  flex: 0 0 25px;\n"], ["\n  flex: 0 0 25px;\n"])));
var InputAreaPane = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  flex: 0 0 44px;\n\n  & > textarea {\n    margin-bottom: 16px;\n  }\n"], ["\n  flex: 0 0 44px;\n\n  & > textarea {\n    margin-bottom: 16px;\n  }\n"])));
exports.FormCellLabel = styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  height: 28px;\n  line-height: 28px;\n  margin-bottom: 8px;\n"], ["\n  height: 28px;\n  line-height: 28px;\n  margin-bottom: 8px;\n"])));
var FormInline = function (props) {
    return (react_1.default.createElement(InlinePane, null,
        !props.label ? null : (react_1.default.createElement(InlineSubLabelPane, null,
            react_1.default.createElement(form_1.SubLabel, null,
                props.label,
                !props.tooltip ? null : react_1.default.createElement(tooltip_1.Tooltip, { tooltip: props.tooltip })))),
        react_1.default.createElement(InlineInputAreaPane, null, props.children)));
};
exports.FormInline = FormInline;
var InlinePane = styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: flex-end;\n  margin-bottom: 16px;\n"], ["\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: flex-end;\n  margin-bottom: 16px;\n"])));
var InlineSubLabelPane = styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  align-self: center;\n"], ["\n  align-self: center;\n"])));
var InlineInputAreaPane = styled_components_1.default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  align-self: center;\n  margin-right: 8px;\n"], ["\n  align-self: center;\n  margin-right: 8px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;
